<template>

    <v-page-body>
        <v-section-info :company="company" />
        <v-section-leave :company="company" />
    </v-page-body>

</template>

<script>

import CompanyApi from '@api/CompanyApi';
import SectionInfo from './components/SectionInfo';
import SectionLeave from './components/SectionLeave';

export default {

    components: {
        'v-section-info': SectionInfo,
        'v-section-leave': SectionLeave,
    },

    data() {
        return {
            company: null,
        }
    },

    mounted() {
        this.getCompany();
    },

    methods: {

        getCompany() {
            this.$store.commit('loading', true);
            CompanyApi.getCompany(this.$store.getters.company.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.company = response.data.data;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

    },

}

</script>